import { apiRequest } from './http';
import type {
  ApiItemResponse,
  As2MessageListQuery,
  As2OutboundMessageRecord,
} from '../types/api';

function queryString(query: As2MessageListQuery): string {
  const search = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      search.set(key, String(value));
    }
  });

  const serialized = search.toString();
  return serialized ? `?${serialized}` : '';
}

// The AS2 gateway paginates with Spring-style `{ content, totalElements }` envelopes
// (not this app's usual `{ data, total, page, pageSize }` shape), so the list call below
// normalizes it into the app's standard list-result shape for reuse with the existing
// list/pagination UI conventions.
interface GatewayPage<T> {
  content: T[];
  totalElements: number;
}

export interface As2OutboundMessageListResult {
  data: As2OutboundMessageRecord[];
  total: number;
  page: number;
  pageSize: number;
}

export async function listAs2OutboundMessages(query: As2MessageListQuery): Promise<As2OutboundMessageListResult> {
  const response = await apiRequest<ApiItemResponse<GatewayPage<As2OutboundMessageRecord>>>(
    `/as2/outbound-messages${queryString(query)}`,
  );
  return {
    data: response.data.content,
    total: response.data.totalElements,
    page: query.page ?? 0,
    pageSize: query.size ?? 20,
  };
}

export async function getAs2OutboundMessage(id: string): Promise<As2OutboundMessageRecord> {
  return (await apiRequest<ApiItemResponse<As2OutboundMessageRecord>>(`/as2/outbound-messages/${id}`)).data;
}
